import React, { FC } from 'react'
import { useFormContext } from 'react-hook-form'
import { PRODUCT_CONFIGURATION_OPTIONS } from 'shared/consts'
import { FormSelect } from 'components/Form'
import { rules } from 'modules/ProjectEdit/constants'
import { IProductForm } from '../types'

import { IFieldProps } from './field.props'

export const ProductTypeField: FC<IFieldProps> = ({ idx }) => {
  const { control } = useFormContext<IProductForm>()

  return (
    <FormSelect
      placeholder="Start typing Type..."
      control={control}
      fieldName={`products.${idx}.configuration`}
      options={PRODUCT_CONFIGURATION_OPTIONS}
      rules={rules?.configuration}
    />
  )
}
